import { render, staticRenderFns } from "./Providers.vue?vue&type=template&id=238a9bff"
import script from "./Providers.vue?vue&type=script&lang=js"
export * from "./Providers.vue?vue&type=script&lang=js"
import style0 from "./Providers.vue?vue&type=style&index=0&id=238a9bff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports